<template>
  <div class="parameterization"></div>
</template>

<script>
export default {
  name: 'NetworkParameterization',
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.parameterization
  &__search-field
    margin: 15px 5px
  &__container
    border: 1px solid var(--color-border-regular)
    border-radius: 5px
    margin-top: 15px
  ::v-deep .table
    margin-bottom: 0
  +media-min-sm()
  +media-min-md()
  +media-min-lg()
</style>
